/* eslint-disable */
import store from '@/store/index.js'
export default {
  getUrlKey: function (name) {
    try {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [''])[1].replace(/\+/g, '%20')) || null
    }catch(err) {

    }
    return null
  },
  validateId: function (id) {
    let tab = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
    let A1 = new Array (1,1,1,1,1,1,1,1,1,1,2,2,2,2,2,2,2,2,2,2,3,3,3,3,3,3 );
    let A2 = new Array (0,1,2,3,4,5,6,7,8,9,0,1,2,3,4,5,6,7,8,9,0,1,2,3,4,5 );
    let Mx = new Array (9,8,7,6,5,4,3,2,1,1);
  
    if ( id.length != 10 ) return false;
    let i = tab.indexOf( id.charAt(0) );
    if ( i == -1 ) return false;
    let sum = A1[i] + A2[i]*9;
  
    for ( i=1; i<10; i++ ) {
      let v = parseInt( id.charAt(i) );
      if ( isNaN(v) ) return false;
      sum = sum + v * Mx[i];
    }
    if ( sum % 10 != 0 ) return false;
    return true;
  },
  // 車主驗證
  validateIdNumber: function(id) {
    const custIdCode = {
      A: '10', // 臺北市
      B: '11', // 臺中市
      C: '12', // 基隆市
      D: '13', // 臺南市
      E: '14', // 高雄市
      F: '15', // 新北市
      G: '16', // 宜蘭縣
      H: '17', // 桃園市
      I: '34', // 嘉義市
      J: '18', // 新竹縣
      K: '19', // 苗栗縣
      L: '20', // 台中縣
      M: '21', // 南投縣
      N: '22', // 彰化縣
      O: '35', // 新竹市
      P: '23', // 雲林縣
      Q: '24', // 嘉義縣
      R: '25', // 台南縣
      S: '26', // 高雄縣
      T: '27', // 屏東縣
      U: '28', // 花蓮縣
      V: '29', // 台東縣
      W: '32', // 金門縣
      X: '30', // 澎湖縣
      Y: '31', // 陽明山管理局
      Z: '33', // 連江縣
    }
    const TWPID = /^[a-zA-Z]{1}[0-9]{9}$/; // TW
    const IMMPID = /^[0-9]{8}[a-zA-Z]{2}$/;  // Immigrant
    const COMPANYID = /^[0-9]{8}$/; // 公司統一編號
    const FOREIGNERID = /^[0-9a-zA-Z]{0,16}$/;  // 外國人統編
  
    const val = id;

    if (!val) { return false }
  
    // 先判斷是否為身份證格式 (1位英文+9位數字)
    if ( TWPID.test(val) ) {
      const n = (custIdCode[val[0].toUpperCase()] + val.substr(1))
              .split('').map((v) => Number(v));
      const sum = n[0] * 1 + n[1] * 9 + n[2] * 8 + n[3] * 7 +
                n[4] * 6 + n[5] * 5 + n[6] * 4 + n[7] * 3 +
                n[8] * 2 + n[9] * 1 + n[10] * 1;
  
      if ( sum % 10 === 0 ) {
        return true
      }
    }
    // 再判斷是否為統編格式 (8位數字)
    else if ( COMPANYID.test(val) ) {
      const sum = [1, 2, 1, 2, 1, 2, 4, 1].map((v, idx) =>
        (v * val[idx]).toString().split('').reduce((a, b) => Number(a) + Number(b), 0))
        .reduce((a, b) => a + b, 0);
  
      if (sum % 5 === 0) {
        return true
      }
     
      if (val[6] === '7' &&  (sum + 1) % 5 === 0 ) {
        return true
      }
    }
    else {
      if (FOREIGNERID.test(val)) {
        return true
      }
    }
  
    return false
  },
  // url 組成
  buildUrl(url, obj) {
    const params = []
  
    Object.keys(obj).forEach((key) => {
      let value = obj[key]
      // 如果值為undefined我們將其置空
      if (typeof value === 'undefined') {
        value = ''
      }
      // 對於需要編碼的文本（比如說中文）我們要進行編碼
      params.push([key, encodeURIComponent(value)].join('='))
    })
  
    return url + '?' +params.join('&')
  },
  // 驗證傳入參數
  validateParams(params) {
    if(params.promoCode && !/^[0-9]{5}$/.test(params.promoCode)) {
      return false
    }
    if(params.promoEmpNo && !/^[0-9]{5}$/.test(params.promoEmpNo)) {
      return false
    }
    if(params.seedNo) {
      try {
        params.seedNo = window.atob(params.seedNo)
      } catch (error) {
        return false
      }    
      if(!/^[a-zA-Z0-9]{1,10}$/.test(params.seedNo)) {
        return false
      }
    }
    if(params.payType && !/^[a-zA-Z0-9]{1,2}$/.test(params.payType)) {
      return false
    }
    return true
  },
  isBlank (str) {
    if (str === undefined || str === null || String(str).trim() === '') {
      return true
    }
    return false
  }
}
